export const GENDER = [
    { label: 'male', value: 'male' },
    { label: 'female', value: 'female' },
];
export const ROLES = [
    { label: 'Super Admin', value: 'sup_admin' },
    { label: 'Admin', value: 'admin' },
    { label: 'Local_Admin', value: 'local_admin' },
    { label: 'Executive', value: 'executive' },
    { label: 'Engineer', value: 'engineer' },
    { label: 'Delivery Executive', value: 'delivery_executive' },
    { label: 'Sales', value: 'sales' }
];
export const VOLUME = [
    { label: 'High', value: 'high' },
    { label: 'Medium', value: 'medium' },
    { label: 'Low', value: 'low' },
];
export const FORM = [
    { label: 'Liquid', value: 'LIQ' },
    { label: 'Powder', value: 'POW' },
    { label: 'SaltFree', value: 'SF' },
    { label: 'Press Cake', value: 'PC' },
    { label: 'Granules', value: 'GR' },
    { label: 'Crystal', value: 'CR' },
];

export const TSHIRT_SIZE = [
    { label: 'S', value: 'S' },
    { label: 'M', value: 'M' },
    { label: 'L', value: 'L' },
    { label: 'XL', value: 'XL' },
    { label: 'Xxl', value: 'Xxl' },
    { label: 'XXxl', value: 'XXxl' },
];
export const FOOD_PREFERENCE = [
    { label: 'Veg', value: 'Veg' },
    { label: 'Non veg', value: 'Non veg' },
    { label: 'Jain', value: 'Jain' },
];
export const MUSIC_PREFERENCE = [
    { label: 'Rock', value: 'Rock' },
    { label: 'Jazz', value: 'Jazz' },
    { label: 'Bollywood party', value: 'Bollywood party' },
    { label: 'Sufi', value: 'Sufi' },
    { label: 'Ghazal', value: 'Ghazal' },
];
export const CREW_MEMBERS = [
    { label: '0', value: '0' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
];
export const TITLE = [
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Ms.', value: 'Ms.' },
    { label: 'Mrs.', value: 'Mrs.' },
];
export const PRODUCT_TYPE = [
    {
        label: 'INK',
        value: 'INK',
    },
    {
        label: 'MACHINE',
        value: 'MACHINE',
    },
];

export const PURCHASE_ORDER_STATUS = [
    {
        label: 'Open',
        value: 'open',
    },
    {
        label: 'In Progress',
        value: 'inProgress',
    },
    {
        label: 'Dispatch',
        value: 'dispatch',
    },
    {
        label: 'Delivered',
        value: 'delivered',
    },
    {
        label: 'Canceled',
        value: 'canceled',
    },
];
export const SPAREPART_PO_STATUS = [
    {
        label: 'Open',
        value: 'open',
    },
    {
        label: 'Delivered',
        value: 'close',
    },
    {
        label: 'Canceled',
        value: 'canceled',
    },
];
export const CATEGORY_OPTIONS = [
    {
        label: 'Machine',
        value: 'MACHINE',
    },
    {
        label: 'Ink',
        value: 'INK',
    },
    {
        label: 'Spare Part',
        value: 'sparePart',
    },
];

export const TERMS_CONDITIONS = [
    {
        value: 'MACHINE',
        notes: [
            '1. All boards with serial nos -- 01 year',
            '2. X y motors -- 09 months.',
            '3. Paper Winding motors : 2 month against manufacturing defects only.',
            '4. Plastic rubber n consumables no warranty after successful installation.',
            '5. Heads: no warranty after successful installation. ONLY for manufacturing defects found in first 3 days',
        ],
    },
    {
        value: 'INK',
        notes: [
            'Ink Term & Conditions1',
            'Ink Term & Conditions2',
            'Ink Term & Conditions3',
        ],
    },
    {
        value: 'sparePart',
        notes: [
            'Spare part Term & Conditions1',
            'Spare part Term & Conditions2',
            'Spare part Term & Conditions3',
        ],
    },
];

export const CURRENCY_OPTIONS = [
    {
        label: 'INR',
        value: 'INR',
    },
    {
        label: 'USD',
        value: 'USD',
    },
    {
        label: 'Other',
        value: 'other',
    },
]

export const MATERIAL_CONDITION_OPTIONS = [
    { label: 'Low', value: 'low' },
    { label: 'Normal', value: 'normal' },
    { label: 'High', value: 'high' },
    { label: 'Other', value: 'other' },
];

export const SHIFTS_OPTIONS = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: 'Other', value: 'other' },
];

export const MACHINE_WARRANTY_OPTIONS = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
    { label: 'Other', value: 'other' },
];

export const PRODUCT_UOM_OPTIONS = [
    { label: 'KGS', value: 'KGS' },
    { label: 'PCS', value: 'PCS' },
    { label: 'ROLL', value: 'ROLL' },
    { label: 'MTR', value: 'MTR' },
    { label: 'SET', value: 'SET' },
    { label: 'Other', value: 'OTHER' },
];
export const COMPETITOR_APPROACH = [
    { label: 'Please Select', value: '' },
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }
]